import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLocale } from '../context/LocaleContext';

const LocaleHead = () => {
  const location = useLocation();
  const { locale, locales, pageAlternates, isAdmin } = useLocale();

  useEffect(() => {
    document.head.querySelectorAll('[data-locale-seo="true"], [data-server-locale-seo="true"]').forEach((node) => node.remove());
    if (isAdmin) return undefined;

    const origin = window.location.origin;
    const parts = location.pathname.split('/').filter(Boolean);
    if (locales.some((item) => item.code === parts[0])) parts.shift();
    const suffix = parts.length ? `/${parts.join('/')}` : '';
    const enabled = locales.filter((item) => item.enabled !== false);

    const appendLink = (rel, href, hreflang) => {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = href;
      if (hreflang) link.hreflang = hreflang;
      link.dataset.localeSeo = 'true';
      document.head.appendChild(link);
    };

    appendLink('canonical', `${origin}${location.pathname}`);
    enabled.forEach((item) => {
      const alternatePath = pageAlternates
        ? pageAlternates[item.code]
        : `/${item.code}${suffix}`;
      if (!alternatePath) return;
      appendLink('alternate', `${origin}${alternatePath}`, item.code);
    });
    const defaultLocale = enabled.find((item) => item.isDefault) || enabled[0];
    if (defaultLocale) {
      const defaultPath = pageAlternates
        ? pageAlternates[defaultLocale.code] || Object.values(pageAlternates)[0]
        : `/${defaultLocale.code}${suffix}`;
      if (defaultPath) appendLink('alternate', `${origin}${defaultPath}`, 'x-default');
    }

    return () => {
      document.head.querySelectorAll('[data-locale-seo="true"], [data-server-locale-seo="true"]').forEach((node) => node.remove());
    };
  }, [isAdmin, locale.code, locales, location.pathname, pageAlternates]);

  return null;
};

export default LocaleHead;
